var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { EngineNodesStateModel } from './engine.nodes.state.model';
import { HoverNode, SelectNode, CheckNode, CheckInverseNodes, SetCheckedNodes, ToggleVisibleNodes, ExpandNode, CollapseNode, ResetEngineNodes, HideInverse, Isolate, CheckAllNodes, TogglePickableNodes, ToggleInversePickableNodes, QueryNodeInfo, QueryNodeInfoFailure, QueryNodeInfoSuccess, SetNodeInfo, PaintNodes, UnpaintNodes } from './engine.nodes.actions';
import { EngineState } from '../engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { EngineService } from '../../engine.service';
import { SetGraph, SynchronizePickableNodes } from '../engine.actions';
import { WikiService } from 'src/app/shared/wiki.service';
import { finalize } from 'rxjs/operators';
import { PaintService } from '../../paint.service';
var initialState = {
    hit: null,
    selectedNode: null,
    hoveredNode: null,
    checkedNodes: [],
    querying: false
};
var EngineNodesState = /** @class */ (function () {
    function EngineNodesState(store, graphService, engineService, wikiService, paintService) {
        this.store = store;
        this.graphService = graphService;
        this.engineService = engineService;
        this.wikiService = wikiService;
        this.paintService = paintService;
    }
    /**
     * Selectors
     */
    EngineNodesState.getHit = function (state) {
        return state.hit;
    };
    EngineNodesState.getHoveredNode = function (state) {
        return state.hoveredNode;
    };
    EngineNodesState.getCheckedNodeIds = function (state) {
        return state.checkedNodes.map(function (node) { return node.id; });
    };
    EngineNodesState.getCheckedNodes = function (state) {
        return state.checkedNodes;
    };
    // TODO: is this used?
    EngineNodesState.getSelectedNode = function (state) {
        return state.selectedNode;
    };
    EngineNodesState.getQuerying = function (state) {
        return state.querying;
    };
    /**
     * Actions
     */
    // TODO: is this used?
    EngineNodesState.prototype.selectNode = function (context, action) {
        context.patchState({
            selectedNode: action.node
        });
    };
    EngineNodesState.prototype.hoverNode = function (context, action) {
        context.patchState({
            hoveredNode: action.node,
            hit: __assign({}, action.hit || null)
        });
    };
    EngineNodesState.prototype.checkNode = function (context, action) {
        var checkedNodes = context.getState().checkedNodes;
        if (action.checked) {
            // Add node
            var hasNode = checkedNodes.some(function (node) { return node.id === action.node.id; });
            if (!hasNode) {
                context.patchState({
                    checkedNodes: __spread(checkedNodes, [action.node])
                });
            }
        }
        else {
            // Remove node
            var nodes = checkedNodes
                .filter(function (node) { return node.id !== action.node.id; });
            context.patchState({
                checkedNodes: __spread(nodes)
            });
        }
    };
    EngineNodesState.prototype.checkAllNodes = function (context, action) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var nodes = Object.values(viewGraph.roots);
        var leaves = this.graphService.getAllLeafDescendants(viewGraph, nodes.map(function (node) { return node.id; }));
        var leafNodes = this.graphService.getNodes(viewGraph, leaves);
        // Update state with the new checked nodes
        context.patchState({
            checkedNodes: __spread(leafNodes)
        });
    };
    EngineNodesState.prototype.checkInverseNodes = function (context, action) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        // Get actual leaves from nodes passed in
        var leaves = this.graphService.getAllLeafDescendants(viewGraph, action.nodes.map(function (node) { return node.id; }));
        // Find the inversion of those leaves
        var inverseNodes = this.graphService.getInverseSelection(viewGraph, leaves);
        var nodes = this.graphService.getNodes(viewGraph, inverseNodes);
        // Update state with the new checked nodes
        context.patchState({
            checkedNodes: __spread(nodes)
        });
    };
    EngineNodesState.prototype.setCheckedNodes = function (context, action) {
        context.patchState({
            checkedNodes: __spread(action.nodes)
        });
    };
    EngineNodesState.prototype.toggleVisibleNodes = function (context, action) {
        var nodeIds = action.nodes.map(function (node) { return node.id; });
        this.engineService.toggleNodes(nodeIds, action.visible);
    };
    EngineNodesState.prototype.togglePickableNodes = function (context, action) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var nodeIds = action.nodes.map(function (node) { return node.id; });
        var changeMap = this.engineService.setNodesPickable(viewGraph, nodeIds, action.pickable);
        this.store.dispatch(new SynchronizePickableNodes(changeMap));
    };
    EngineNodesState.prototype.toggleInversePickableNodes = function (context, action) {
        var nodeIds = action.nodes.map(function (node) { return node.id; });
        var inverseNodeIds = this.graphService.getInverseSelection(action.viewGraph, nodeIds);
        var nodes = this.graphService.getNodes(action.viewGraph, inverseNodeIds);
        this.store.dispatch(new TogglePickableNodes(nodes, action.pickable));
    };
    EngineNodesState.prototype.expandNode = function (context, action) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var ancestors = this.graphService.getAncestors(viewGraph, action.node.id, true);
        ancestors.forEach(function (id) {
            viewGraph.nodes[id].boolState.expanded = true;
        });
        this.store.dispatch(new SetGraph(viewGraph));
    };
    EngineNodesState.prototype.collapseNode = function (context, action) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        viewGraph.nodes[action.node.id].boolState.expanded = false;
        this.store.dispatch(new SetGraph(viewGraph));
    };
    EngineNodesState.prototype.resetEngineNodes = function (context, action) {
        context.setState(initialState);
    };
    EngineNodesState.prototype.hideInverse = function (context, action) {
        var nodeIds = action.nodes.map(function (node) { return node.id; });
        var inverseNodeIds = this.graphService.getInverseSelection(action.viewGraph, nodeIds);
        var nodes = this.graphService.getNodes(action.viewGraph, inverseNodeIds);
        this.store.dispatch(new ToggleVisibleNodes(nodes, false));
    };
    EngineNodesState.prototype.isolate = function (context, action) {
        this.store.dispatch(new HideInverse(action.nodes, action.viewGraph));
        this.store.dispatch(new ToggleVisibleNodes(action.nodes, true, false));
    };
    EngineNodesState.prototype.queryNodeInfo = function (context, _a) {
        var node = _a.node;
        // begin querying
        context.patchState({ querying: true });
        // query wiki service
        this.wikiService.getWikiText(node.label)
            .pipe(
        // end querying
        finalize(function () { return context.patchState({ querying: false }); }))
            .subscribe(
        // success
        function (wikiDescription) { return context.dispatch(new QueryNodeInfoSuccess(node, wikiDescription)); }, 
        // failure
        function () { return context.dispatch(new QueryNodeInfoFailure(node)); });
    };
    EngineNodesState.prototype.queryNodeInfoSuccess = function (context, _a) {
        var node = _a.node, description = _a.description;
        context.dispatch(new SetNodeInfo(node, description));
    };
    EngineNodesState.prototype.setNodeInfo = function (context, _a) {
        var node = _a.node, description = _a.description;
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var viewNode = viewGraph.nodes[node.id];
        if (viewNode) {
            viewNode.description = description;
            this.store.dispatch(new SetGraph(viewGraph));
            var selectedNode = context.getState().selectedNode;
            /*
            context.patchState({
              selectedNode: null
            });
            */
            context.patchState({
                selectedNode: selectedNode
            });
        }
    };
    EngineNodesState.prototype.paintNodes = function (context, _a) {
        var nodes = _a.nodes, recipe = _a.recipe;
        this.paintService.paintAll(nodes, recipe);
    };
    EngineNodesState.prototype.unpaintNodes = function (context, _a) {
        var _this = this;
        var nodes = _a.nodes;
        nodes.forEach(function (node) {
            _this.paintService.unpaint(node);
        });
    };
    __decorate([
        Action(SelectNode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectNode]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "selectNode", null);
    __decorate([
        Action(HoverNode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, HoverNode]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "hoverNode", null);
    __decorate([
        Action(CheckNode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckNode]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "checkNode", null);
    __decorate([
        Action(CheckAllNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckAllNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "checkAllNodes", null);
    __decorate([
        Action(CheckInverseNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckInverseNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "checkInverseNodes", null);
    __decorate([
        Action(SetCheckedNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetCheckedNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "setCheckedNodes", null);
    __decorate([
        Action(ToggleVisibleNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ToggleVisibleNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "toggleVisibleNodes", null);
    __decorate([
        Action(TogglePickableNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, TogglePickableNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "togglePickableNodes", null);
    __decorate([
        Action(ToggleInversePickableNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ToggleInversePickableNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "toggleInversePickableNodes", null);
    __decorate([
        Action(ExpandNode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ExpandNode]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "expandNode", null);
    __decorate([
        Action(CollapseNode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CollapseNode]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "collapseNode", null);
    __decorate([
        Action(ResetEngineNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetEngineNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "resetEngineNodes", null);
    __decorate([
        Action(HideInverse),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, HideInverse]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "hideInverse", null);
    __decorate([
        Action(Isolate),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Isolate]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "isolate", null);
    __decorate([
        Action(QueryNodeInfo),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, QueryNodeInfo]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "queryNodeInfo", null);
    __decorate([
        Action(QueryNodeInfoSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, QueryNodeInfoSuccess]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "queryNodeInfoSuccess", null);
    __decorate([
        Action(SetNodeInfo),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetNodeInfo]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "setNodeInfo", null);
    __decorate([
        Action(PaintNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, PaintNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "paintNodes", null);
    __decorate([
        Action(UnpaintNodes),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UnpaintNodes]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState.prototype, "unpaintNodes", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineNodesStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState, "getHit", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineNodesStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState, "getHoveredNode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineNodesStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState, "getCheckedNodeIds", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineNodesStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState, "getCheckedNodes", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineNodesStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState, "getSelectedNode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [EngineNodesStateModel]),
        __metadata("design:returntype", void 0)
    ], EngineNodesState, "getQuerying", null);
    EngineNodesState = __decorate([
        State({
            name: 'engineNodes',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [Store,
            BdGraphService,
            EngineService,
            WikiService,
            PaintService])
    ], EngineNodesState);
    return EngineNodesState;
}());
export { EngineNodesState };
